import React, { useState, useEffect } from "react";
import "./allQuestions.css";
import QuestionnoboxHW from "../Completed_component/question_no_box/QuestionnoboxHW";
import Textquestion from "./Textquestion.";
import UploadQuestion from "./UploadQuestion";
import McqQuestion from "./McqQuestion";
import { Link, NavLink, useLocation } from "react-router-dom";
import axios from "../../../../axios";
import SuccessfullCompleted from "../SuccessfullCompleted/SuccessfullCompleted";
import {
  Box,
  Button,
  Chip,
  getMenuItemUtilityClass,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
const AllQuestionsCompletedHW = () => {
  const navigate = useNavigate();
  let question = [];
  const [disable, setDisable] = useState(true);
  const [clickedno, setClickedNo] = useState(1);
  const [questions, setQuestions] = useState([]);
  const [generalinfo, setGeneralInfo] = useState([]);
  const [successlclick, setSuccessClick] = useState(false);
  const [clickedHeader, setClickedHeader] = useState("");
  const [isError, setIsError] = useState(false);
  //Added this state by kuldeep
  const { state } = useLocation();

  const helper = () => {
    // let res = localStorage.getItem("clickedHeader");
    if (state.Status === "Completed") {
      return `/CompleteStudentListHW`;
    } else {
      return `/onreviewstudentlistHW`;
    }
  };
  //Remove useState by kuldeep
  useEffect(() => {
    let res = localStorage.getItem("clickedHeader");
    setClickedHeader(res);
    axios
      .get(
        `/api/v1/homework/${state.homework_id}/studentResult/student/${state.student_id}/get`
      )
      .then((response) => {
        setGeneralInfo(response.data.data);
        response.data.data.results.forEach((obj) => {
          // I added (obj.question_response.question.type.type === "multiple choice" || !obj.question_response.question.type.is_manually_graded) I compare question type with type same as android side
          if (
            obj.question_response.question.type.type === "multiple choice" ||
            !obj.question_response.question.type.is_manually_graded
          ) {
            let res = {
              type: obj.question_response.question.type.type,
              question_title: obj.question_response.question.title,
              option: obj.question_response.question.options,
              student_choice: obj.question_response.answer,
              comment: obj.comment,
              totalM: obj.question_response.question.correct_score,
              obtained_marks: obj.obtained_marks,
              updatedAt: obj.updatedAt,
              correct_ans: obj.question_response.question.correct_answers[0],
              attachments: obj.question_response.question.attachments,
              attachments_sizeKb:
                obj.question_response.question.attachments_sizeKb,
            };
            question.push(res);
          } else if (
            // I added (obj.question_response.question.type.type === "descriptive" || obj.question_response.question.type.is_manually_graded) I compare question type with type same as android side
            obj.question_response.question.type.type === "descriptive" ||
            obj.question_response.question.type.is_manually_graded
          ) {
            let res = {
              type: obj.question_response.question.type.type,
              question_title: obj.question_response.question.title,
              teacher_attachment: obj.question_response.question.attachments,
              student_attachment: obj.question_response.attachments,
              comment: obj.comment,
              descriptive_answer: obj.question_response.descriptive_answer,
              obtained_marks: obj.obtained_marks,
              totalM: obj.question_response.question.correct_score,
              updatedAt: obj.updatedAt,
              correct_ans: obj.question_response.question.correct_answers[0],
              attachments: obj.question_response.question.attachments,
              attachments_sizeKb:
                obj.question_response.question.attachments_sizeKb,
            };
            question.push(res);
          }
          setQuestions(question);
        });
      })
      .catch((e) => {
        setIsError(true);
        toast.error("Something went wrong for selected card!!");
      });
  }, []);

  const timeHelper = (a) => {
    const inputDateString = a;
    const dateObj = new Date(inputDateString);
    const day = dateObj.getUTCDate();
    const month = dateObj.getUTCMonth() + 1;
    const year = dateObj.getUTCFullYear();
    const outputDateString = `${day}/${month}/${year}`;
    return outputDateString;
  };
  const renderQuestion = () => {
    const currentQuestion = questions[clickedno - 1];
    // I added (currentQuestion?.type === "multiple choice") I compare question type with type same as android side
    if (currentQuestion?.type === "multiple choice") {
      return (
        <McqQuestion
          currentQuestion={currentQuestion}
          currentQuestionIndex={clickedno - 1}
        />
      );
    } else if (
      // I added (currentQuestion?.type === "descriptive") I compare question type with type same as android side
      currentQuestion?.type === "descriptive"
    ) {
      return (
        <UploadQuestion
          currentQuestion={currentQuestion}
          currentQuestionIndex={clickedno - 1}
        />
      );
    }
  };
  const handleNext = () => {
    let res = parseInt(clickedno) + 1;
    setClickedNo(res);
  };
  const handlePrevious = () => {
    let res = clickedno - 1;
    setClickedNo(res);
  };
  useEffect(() => {
    if (clickedno > questions.length && clickedno !== 1) {
      setSuccessClick(true);
      if (state.Status === "completed") {
        navigate("/CompleteStudentListHW", {
          state: { homework_id: state?.homework_id },
        });
      } else {
        navigate("/onreviewstudentlistHW", {
          state: { homework_id: state?.homework_id },
        });
      }
    } else {
      setSuccessClick(false);
    }
    if (clickedno === 1) {
      setDisable(true);
    } else {
      setDisable(false);
    }
  }, [clickedno]);
  // console.log(questions);
  const urlParams = new URLSearchParams(window.location.search);
  const Name = urlParams.get("Name");

  function formatDate(inputDate) {
    if (!inputDate) return null;
    const date = new Date(inputDate);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;

    return `${day}/${month}/${year}`;
  }
  const Deadline = formatDate(generalinfo?.homework?.deadline);
  const Evaluated = formatDate(generalinfo.evaluation_on);
  return (
    <div style={{ height: "100vh", background: "#f5f6fa" }}>
      {/* ================= HEADER ================= */}
      <Paper
        elevation={1}
        sx={{
          p: 2,
          borderRadius: 2,
          mx: 2,
          mt: 2,
        }}
      >
        <Stack spacing={1}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <img
              src="/images/Back Arrow.svg"
              alt=""
              style={{ cursor: "pointer" }}
              onClick={() =>
                navigate(helper(), {
                  state: { homework_id: state?.homework_id },
                })
              }
            />

            <Typography variant="body2" fontWeight={600}>
              Homework /
            </Typography>

            <Typography variant="body2" fontWeight={600}>
              {generalinfo?.homework?.name}
            </Typography>

            <Typography variant="body2" color="text.secondary">
              | {Name}
            </Typography>

            <Chip size="small" color="success" label="Completed" />

            <Typography variant="body2">
              {generalinfo?.homework?.subject_id?.name}
            </Typography>

            <Typography variant="body2" color="text.secondary">
              | Deadline
            </Typography>

            <Typography variant="body2">{Deadline}</Typography>

            <Typography variant="body2" color="text.secondary">
              | Evaluated On
            </Typography>

            <Typography variant="body2">{Evaluated}</Typography>
          </Stack>

          <Typography variant="body2" color="text.secondary" maxWidth="80%">
            {generalinfo?.homework?.description}
          </Typography>
        </Stack>
      </Paper>

      {/* ================= QUESTION NAV ================= */}
      {questions && questions.length > 0 && (
        <Paper
          elevation={0}
          sx={{
            mx: 2,
            mt: 2,
            p: 1.5,
            borderRadius: 2,
          }}
        >
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <QuestionnoboxHW
              questions={questions}
              setClickedNo={setClickedNo}
            />

            <Stack direction="row" spacing={1}>
              {questions.length > 1 && (
                <Button
                  variant="contained"
                  disabled={disable}
                  onClick={handlePrevious}
                  sx={{
                    backgroundColor: "#F28C28",
                    color: "#fff",
                    fontWeight: 600,
                    "&:hover": { backgroundColor: "#d97706" },
                  }}
                >
                  Previous
                </Button>
              )}

              <Button
                variant="contained"
                onClick={handleNext}
                sx={{
                  backgroundColor: "#F28C28",
                  color: "#fff",
                  fontWeight: 600,
                  "&:hover": { backgroundColor: "#d97706" },
                }}
              >
                Next
              </Button>
            </Stack>
          </Stack>
        </Paper>
      )}

      {/* ================= QUESTIONS SCROLL AREA ================= */}
      <Box
        sx={{
          mx: 2,
          mt: 2,
          height: "calc(100vh - 260px)",
          overflowY: "auto",
          pb: 2,
        }}
        className="orange-scrollBar"
      >
        {questions && questions.length > 0 && !successlclick && (
          <>{renderQuestion()}</>
        )}

        {!questions.length && !isError && (
          <img className="Loader" src="/gif/LoaderDot.gif" alt="" />
        )}

        {isError && (
          <Typography color="error" align="center">
            Record Not Found!!
          </Typography>
        )}

        {successlclick && (
          <img className="Loader" src="/gif/LoaderDot.gif" alt="" />
        )}
      </Box>
    </div>
  );
};

export default AllQuestionsCompletedHW;
